import { get } from './fetch'

export const getSettings = () => {
  return get(`settings`)
}
